export const text = {
  backToMyGardens: 'Back to Gardens',
  gardenTools: 'Garden Tools',
  shareGarden: 'Share Garden',
  linkCopied: 'Link Copied!',
  gridControls: 'Grid Controls',
  rows: 'Rows',
  columns: 'Columns',
  removeRow: 'Remove Row',
  addRow: 'Add Row',
  removeColumn: 'Remove Column',
  addColumn: 'Add Column',
  plantSelectionToggleTitle: 'Toggle Plant Selection Mode',
  exitPlantSelection: 'Exit Plant Selection',
  selectPlant: 'Select Plant',
  availabilityToggleTitle: 'Toggle Cell Availability Mode',
  exitAvailability: 'Exit Availability',
  editAvailability: 'Edit Availability',
  availabilityHint: 'Click cells in the grid to toggle their availability',
  enableAll: 'Enable All',
  enableAllTitle: 'Enable all cells',
  disableAll: 'Disable All',
  disableAllTitle: 'Disable all cells from planting',
  cellSettingsToggleTitle: 'Toggle Cell Settings Mode',
  exitCellSettings: 'Exit Cell Settings',
  editCellSettings: 'Edit Cell Settings',
  slotsPerCell: 'Slots per Cell',
  decreaseSlots: 'Decrease slots',
  increaseSlots: 'Increase slots',
  bulkEditMode: 'Bulk Edit Mode',
  bulkClickCells: 'Click cells to select them',
  bulkCellsSelected: (count: number) => `${count} cell${count === 1 ? '' : 's'} selected`,
  saveToCells: (count: number) => `Save to ${count} cell${count === 1 ? '' : 's'}`,
  cellPosition: (row: number, col: number) => `Row ${row}, Col ${col}`,
  clearSelection: 'Clear selection',
  saveCellSettings: 'Save Cell Settings',
  clickCellToSelect: 'Click a cell to select it',
  clearPlantsToggleTitle: 'Toggle Clear Plants Mode',
  exitClearMode: 'Exit Clear Mode',
  clearPlants: 'Clear Plants',
  clearPlantsHint: 'Click cells in the grid to remove plants',
  clearAllPlants: 'Clear All Plants',
  clearAllPlantsTitle: 'Remove all plants from the garden',
  openSidebar: 'Open sidebar',
  closeSidebar: 'Close sidebar',
  dismissAlert: 'Dismiss',
  gardenSummary: 'Planting Summary',
  planted: (count: number) => `${count} Planted`,
  freeSpots: (count: number) => `${count} Free Spots`,
  noPlantsYet: 'No plants in this garden yet',
  plantSelectorTitle: 'Compact Layout with Search',
  searchOrSelect: 'Search or select',
  searchPlants: 'Search plants...',
  noPlantsFound: 'No plants found.',
  yourPlantBadge: 'Yours',
  plantedCount: (count: number) => `${count} planted`,
  nonePlanted: 'None planted',
  removeRowTitle: 'Remove Row?',
  removeColumnTitle: 'Remove Column?',
  removeRowMessage: (count: number) =>
    `This will remove ${count} plant${count === 1 ? '' : 's'} from the last row. This action cannot be undone.`,
  removeColumnMessage: (count: number) =>
    `This will remove ${count} plant${count === 1 ? '' : 's'} from the last column. This action cannot be undone.`,
  cellLabel: (row: number, col: number) => `Cell ${row + 1}-${col + 1}`,
  cellAvailabilityEnable: 'Click to enable planting',
  cellAvailabilityDisable: 'Click to disable planting',
  cellClearAll: (row: number, col: number, count: number) =>
    `${`Cell ${row + 1}-${col + 1}`}\nClick to clear all plants (${count})`,
  cellNoPlantsToClear: (row: number, col: number) =>
    `${`Cell ${row + 1}-${col + 1}`}\nNo plants to clear`,
  cellNotAvailable: (row: number, col: number) =>
    `${`Cell ${row + 1}-${col + 1}`}\nNot available for planting`,
  plantVarietyLabel: (speciesName: string, varietyName: string) =>
    `${speciesName} — ${varietyName}`,
  cellWithPlantNames: (row: number, col: number, plantNames: string[]) =>
    `${`Cell ${row + 1}-${col + 1}`}\n${plantNames.join('\n')}`,
};
